import { useMutation, useQueryClient } from 'react-query';
import { FileType } from '../../../enums/FileType';
import { API } from '../../../utils/ApiClient';

function useUploadFileComment(taskId?: string) {
    const queryClient = useQueryClient();

    return useMutation<{ status: number }, unknown, { file: File }>({
        mutationFn: ({ file }) => {
            const data = new FormData();
            data.append(FileType.COMMENT, file, file.name);
            return API.post(`/comments/uploadfile/${taskId}`, data);
        },
        onSuccess() {
            queryClient.invalidateQueries(`comments/list/`);
        },
    });
}

export default useUploadFileComment;
